"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
require("@hotmart/cosmos/dist/loading");
const loading_module_scss_1 = __importDefault(require("./loading.module.scss"));
const Loading = ({ className, center = false, overlay = false, ...props }) => ((0, jsx_runtime_1.jsx)("hot-loading", { class: (0, classnames_1.default)(className, {
        '_min-w-full _d-flex _justify-content-center': center || overlay,
        [loading_module_scss_1.default.overlay]: overlay
    }), ...props }));
exports.default = Loading;
